import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { GetAPI } from "src/api/request";
import HomePage from "src/pages/HomePage";

/** Resolve a pre-printed QR before HomePage mounts and starts its API queries. */
const QrResolvedHome = () => {
  const { mid, qid } = useParams<{ mid: string; qid: string }>();
  const navigate = useNavigate();
  const [ready, setReady] = useState(!qid);

  useEffect(() => {
    if (!qid) {
      setReady(true);
      return;
    }
    setReady(false);
    GetAPI(`/customer/qr/${qid}`)
      .then((response: any) => {
        const mapped = response?.data?.merchant_id;
        if (mapped && mapped !== mid) {
          navigate(`/${mapped}/${qid}`, { replace: true });
          return;
        }
        setReady(true);
      })
      .catch(() => setReady(true));
  }, [mid, qid, navigate]);

  if (!ready) return null;
  return <HomePage />;
};

export default QrResolvedHome;
